var heading_default = {
  "fontElementMap": "_8SOy5",
  "elementSpacing": "iKsfI",
  "headerOne": "zehuh iKsfI",
  "headerTwo": "zl84N iKsfI",
  "headerThree": "W4yfo iKsfI",
  "headerFour": "Zzabv iKsfI",
  "headerFive": "PXG-I iKsfI",
  "headerSix": "rsXNj iKsfI",
  "child": "cj6-S"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
